import {useWebView} from '@/common-pages/hooks/webview.hooks';
import Spin from '@/components/basic/spin';
import React, {useCallback, useState} from 'react';
import {useGameUrlWithToken} from './useGameUrl';
import {PATH} from './const';
import {useShare} from '@/common-pages/hooks/share.hooks';
import {useLatest} from '@/common-pages/hooks/useLatest';
import {createGameMessageHandler} from './handleMessage';
import {useFocusEffect} from '@react-navigation/native';
import theme from '@/style';
function Scratch() {
  const [pageLoading, setPageLoading] = useState(true);
  const {url} = useGameUrlWithToken(PATH.default);
  const {shareGame, initShare} = useShare();
  const latestShareGame = useLatest(shareGame);
  const {render, postMessage} = useWebView({
    originUrl: url,
    onLoadEnd: () => {
      setPageLoading(false);
      initShare();
    },
    onMessage: createGameMessageHandler({
      onShare: () => latestShareGame.current(),
    }),
  });
  useFocusEffect(
    useCallback(() => {
      postMessage?.({
        type: 'tab-show',
      });

      return () => {
        postMessage?.({
          type: 'tab-hide',
        });
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );
  return (
    <div className="h-full w-full pb-[56px]" key={url}>
      <Spin loading={pageLoading} style={theme.fill.fill}>
        {render}
      </Spin>
    </div>
  );
}

export default Scratch;
